import React, { useState, useEffect } from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { Search, ListUl, Grid3x3GapFill } from 'react-bootstrap-icons';
import Select from "react-select";
import axios from 'axios';
import moment from 'moment';
import DatePicker from 'react-datepicker';

import '/node_modules/bootstrap/dist/js/bootstrap.bundle.min.js';

import "react-datepicker/dist/react-datepicker.css";
import '../assets/css/custom.css';
import '../assets/css/main.css';

import Footer from "../components/Footer";
import AutoSchBox from '../components/AutoSchBox';
import { apiUrl, options, AND, OR, NOT, images } from '../config';

import TFAILogoMain from '../assets/images/TFAI-logo-main.svg'
import ListUpBannerAll from '../assets/images/cnt-head-00.jpg'
import ToFirst from '../assets/images/i-L03.svg'
import BackTen from '../assets/images/i-L02.svg'
import BackOne from '../assets/images/i-L01.svg'
import ToLast from '../assets/images/i-R03.svg'
import ForwardTen from '../assets/images/i-R02.svg'
import ForwardOne from '../assets/images/i-R01.svg'

const List = () => {
  const [queryParams] = useSearchParams();
  const keyword = queryParams.get('keyWord'); // 查詢關鍵字
  const advancesearch = JSON.parse(queryParams.get('advanceSearch')); // 進階查詢關鍵字
  const startdate = queryParams.get('startDate'); // 年代起
  const enddate = queryParams.get('endDate');   // 年代迄
  const sPage = queryParams.get('page');   // 起始頁數
  const [selectedOptionsJSON, setSelectedOptionsJSON] = useState(JSON.parse(queryParams.get('selectedOptions')));
  const [sDate, setSDate] = useState(startdate ? new Date(startdate + '-01-01') : startdate);
  const [eDate, setEDate] = useState(enddate ? new Date(enddate + '-01-01') : enddate);
  const [ascText, setAscText] = useState('由小至大'); // 預設排序方向呈現文字
  const [descText, setDescText] = useState('由大至小'); // 預設排序方向呈現文字

  const [searchWord, setSearchWord] = useState(keyword)           // 查詢關鍵字
  const [highlightWord, setHighlightWord] = useState(keyword)     // 關鍵字  
  const [searchArray, setSearchArray] = useState([])              // highlight字
  const [headPic, setHeadPic] = useState(null);                   // 圖片
  const [isGrid, setIsGrid] = useState(true);                     // 列表 || 圖示  
  const [orderColumn, setOrderColumn] = useState('標題相關性');    // 排序欄位
  const [orderType, setOrderType] = useState('DESC');             // 排序方向  
  const [items, setItems] = useState();                           // 查詢結果數據
  const [totalCount, setTotalCount] = useState(0);                // 總筆數
  const [totalPage, setTotalPage] = useState(0);                  // 總頁數  
  const [page, setPage] = useState(sPage ? sPage : 1)             // 當前頁數
  const [recordsperpage, setRecordsPerPage] = useState(20)        // 每頁呈現的筆數  
  const [inputRef, setInputRef] = useState(0); // 輸入框的寬度
  const [showAutofillList, setShowAutofillList] = useState(false);
  const [isAdvance, setIsAdvance] = useState(advancesearch.length > 0 ? true : false)
  const [btnText, setBtnText] = useState(advancesearch.length > 0 ? '一般查詢' : '進階搜尋')
  const [data, setData] = useState(advancesearch.length > 0 ? advancesearch : [{ select: AND, input: "" }]); //進階查詢關鍵字

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (isAdvance) {
      document.getElementById("advanceBtn").className = "accordion-button"
      document.getElementById("adv-search").className = "accordion-collapse collapse show"
    }
    highlightArray()
  }, [])

  useEffect(() => {
    if (isAdvance) {
      setBtnText('一般查詢')
    } else {
      setBtnText('進階查詢')
    }
  }, [isAdvance])

  const advanceBtn = () => {
    setIsAdvance(!isAdvance)
    setData([{ select: AND, input: "" }])
  }

  const handleAdd = () => {
    const temp = [...data, { select: AND, input: "" }]
    setData(temp)
  }
  const handleChange = (onChangeValue, i) => {
    const { name, value } = onChangeValue.target
    const inputdata = [...data]
    inputdata[i][name] = value;
    setData(inputdata)
  }
  const handleDelete = () => {
    const delVal = [...data]
    delVal.splice(-1, 1)
    setData(delVal)
  }

  const highlightArray = () => {
    if (isAdvance) {
      const tempStr = data.map(val => val.input.trim() !== '' ? val.select + val.input.trim() : '').join('')
      setHighlightWord(searchWord.concat(tempStr));
      const temp = searchWord !== '' ? [searchWord] : [];
      const inputdata = temp.concat(...data.filter(val => val.select !== NOT && val.input.trim() !== '').map(val => val.input.trim()))
      setSearchArray(inputdata)
    } else {
      if (searchWord !== '') {
        const array = searchWord.trim().split(/\s+/)
        setSearchArray(array)
        setHighlightWord(array.join(AND))
      } else {
        setSearchArray([])
        setHighlightWord('')
      }
    }
  }

  useEffect(() => {
    setPage(1)
    setSelectedOptionsJSON(JSON.parse(queryParams.get('selectedOptions')))
  }, [queryParams.get('selectedOptions')])

  useEffect(() => {
    const selectedOptionsMap = new Map();
    for (const option of selectedOptionsJSON) {
      selectedOptionsMap.set(option.value, option.label);
    }
    if (selectedOptionsMap.size === 1) {
      for (const option of images) {
        if (selectedOptionsMap.has(option.value)) {
          if (option.imageData != null) {
            setHeadPic(`data:image/jpeg;base64,${option.imageData}`);
          } else {
            setHeadPic(ListUpBannerAll);
          }
        }
      }
    } else {
      setHeadPic(ListUpBannerAll);
    }
  }, [selectedOptionsJSON]);

  // 下拉選單排序欄位
  const changeOrderValue = (event) => {
    setOrderColumn(event.target.value)
    if (event.target.value === '藏品名稱') {
      setOrderType("ASC")
    } else {
      setOrderType("DESC")
    }

    if (event.target.value === '資料更新時間') {
      setAscText('由舊至新');
      setDescText('由新至舊');
    } else {
      setAscText('由小至大');
      setDescText('由大至小');
    }

  }
  // 下拉選單排序大小
  const changeDirectionValue = (event) => {
    setOrderType(event.target.value)
  }

  useEffect(() => {
    window.addEventListener('keydown', handleKeyPress);
    window.addEventListener('click', handleOutsideClick);
    window.addEventListener('resize', handleResize);
    window.addEventListener('keypress', enterSearch);
    return () => {
      window.removeEventListener('keydown', handleKeyPress);
      window.removeEventListener('click', handleOutsideClick);
      window.removeEventListener('resize', handleResize);
      window.removeEventListener('keypress', enterSearch);
    };
  }, [showAutofillList]);

  const handleResize = () => {
    setInputRef(document.getElementById('input-keyword').clientWidth);
  };
  const handleKeyPress = (event) => {
    if (event.key === 'Escape') {
      setShowAutofillList(false)
    }
  };
  const handleOutsideClick = () => {
    setShowAutofillList(false)
  };
  const enterSearch = (event) => {
    if (event.key === 'Enter') {
      document.getElementById("submit").click()
    }
  };

  const searchWordInput = (event) => {
    setInputRef(document.getElementById('input-keyword').clientWidth);
    setSearchWord(event.target.value)
    if (event.target.value !== "") {
      setShowAutofillList(true)
    } else {
      setShowAutofillList(false)
    }
  }

  const handleSearch = async () => {
    // 如果進階選單是「展開」的 (isAdvance 為 true)
    if (isAdvance) {
      // 檢查 data 陣列中，是否 "有任何一個" (some) input 是空的
      const hasEmptyField = data.some(item => item.input.trim() === "");
      if (hasEmptyField) {
          alert("您已展開進階查詢，請輸入查詢條件，或關閉進階查詢視窗。");
          return;
      }
    }
    if (page !== 1) {
      setPage(1)
    } else {

      setLoading(true); // ⭐ 查詢開始：顯示 loading
      await fetchData()
    }
  }

  const handleSelect = (selectedOptions) => {
    setPage(1)
    setSelectedOptionsJSON(selectedOptions)
  };

  // 獲取數據
  useEffect(() => {
    setLoading(true); // ⭐ 查詢開始：顯示 loading
    fetchData()
  }, [orderColumn, orderType, selectedOptionsJSON, page, sDate, eDate])

  // 發送HTTP請求獲取數據
  const fetchData = async () => {

    try {
      let keys = ''
      let advance = []
      if (isAdvance) {
        keys = searchWord
        advance = data
      } else {
        if (searchWord !== '') {
          const array = searchWord.trim().split(/\s+/)
          keys = array.join(AND)
        }
      }
      let response = await axios.get(apiUrl + '/collection', {
        params: {
          currentPage: page,
          recordsPerPage: recordsperpage,
          keyWord: keys,
          advanceSearch: encodeURIComponent(JSON.stringify(advance)),
          selectedOptions: encodeURIComponent(JSON.stringify(selectedOptionsJSON)),
          sorting: orderColumn,
          direction: orderType,
          startDate: sDate ? sDate.getFullYear().toString() : '',
          endDate: eDate ? eDate.getFullYear().toString() : ''
        }
      })
      setItems(response.data.collectiblesList)  // 濾掉所有換行字符,再轉換成json對像然後設置取得數據
      const { currentPage, recordsPerPage, keyWord, sorting, direction, totalElements, totalPages } = response.data;
      if (isAdvance) {
        setSearchWord(keyWord)
      } else {
        setSearchWord(keyWord.split(new RegExp(`${AND}`, 'i')).join(' '))
      }
      highlightArray()
      setPage(currentPage)
      setRecordsPerPage(recordsPerPage)
      setOrderColumn(sorting)
      setOrderType(direction)
      setTotalCount(totalElements)
      setTotalPage(totalPages)

      // alert("發送HTTP請求獲取數據")
    } catch (error) {
      console.error('Error fetching data:', error)
      // alert('數據查詢出現錯誤!')
    } finally {
      setLoading(false); // ⭐ 查詢結束：隱藏 loading
    }
  }

  // 改變每頁顯示數量
  const changeRecordsPerPage = (event) => {
    setRecordsPerPage(Number(event.target.value))
  }
  // 改變目前頁碼
  const changeCurrentPage = (event) => {
    const page = parseInt(event.target.value, 10)
    if (page >= 1 && page <= totalPage) {
      setPage(page)
    }
  }

  // 跳至第一頁
  const toFirstPage = () => {
    setPage(1)
  }
  // 跳至前十頁
  const toPrevPage10 = () => {
    if (page > 10) {
      setTimeout(() => {
        setPage(page - 10);
      }, 200);
    } else {
      setPage(1)
    }
  }
  // 跳至前一頁
  const toPrevPage1 = () => {
    if (page > 1) {
      setTimeout(() => {
        setPage(page - 1);
      }, 200);
    }
  }
  // 跳至後一頁
  const toNextPage1 = () => {
    if (page < totalPage) {
      setTimeout(() => {
        setPage(page + 1);
      }, 200);
    }
  }
  // 跳至後十頁
  const toNextPage10 = () => {
    if (page < totalPage - 10) {
      setTimeout(() => {
        setPage(page + 10);
      }, 200);
    } else {
      setPage(totalPage)
    }
  }
  // 跳至最後一頁
  const toLastPage = () => {
    setPage(totalPage)
  }

  // 判斷關鍵字是否需要添加 highlight 樣式 
  const renderWithHighlight = (text) => {
    if (searchArray.length > 0 && text !== null) {
      const sortedArray = searchArray.sort((a, b) => b.length - a.length);
      const regex = new RegExp(sortedArray.join('|'), 'gi');
      // Matches array needed to maintain the correct letter casing
      const matches = [...text.matchAll(regex)];
      return text.split(regex).map((part, index) => (
        `${part}${index < matches.length ? `<div key=${index} style="background-color: rgb(255, 255, 94); color: black; display: unset;">${matches[index]}</div>` : ''}`
      )).join('');
    }
    return text;
  };
  const renderWithHighlight1 = (text) => {
    const wordArray = text.split(new RegExp(`(${AND}|${OR}|${NOT})`, 'i'));
    let skipNext = false
    return wordArray.map((element, index) => {
      if (element === AND) {
        skipNext = false
        return 'AND';
      } else if (element === OR) {
        skipNext = false
        return 'OR';
      } else if (element === NOT) {
        skipNext = true
        return 'NOT';
      } else if (!skipNext) {
        return `<div key=${index} style="background-color: rgb(255, 255, 94); color: black; display: unset;">${element}</div>`;
      } else {
        return element;
      }
    }).join('');
  }
  // const renderWithHighlight2 = (text) => {
  //   return "編號：" + renderWithHighlight(text)
  // }

  const listDate = (item) => {
    let type = item.categoryJson.category_id
    let dateName = ""
    switch (type) {
      case "film":
        dateName = "出品日期：";
        break;
      case "item":
        dateName = "廠牌/規格-時間：";
        break;
      case "df":
        dateName = "事件起日：";
        break;
      case "rf":
        dateName = "數位修復年度：";
        break;
      default:
        dateName = "年份：";
        break;
    }
    return dateName + getYear(item.collectiblesDate, type)
  }
  const getYear = (date, type) => {
    if (date) {
      if (type !== "df") {
        return moment(date).format('YYYY');
      } else {
        return date
      }
    }
    return ""
  }

  const gridPic = (item) => {
    if (item.categoryJson.category_id === "item") {
      const array = item.picUrl.split('|')
      return array[0]
    } else {
      return item.picUrl
    }
  }

  const sendData = (item) => {
    localStorage.setItem('collectiblesId', item.collectiblesIndexId);
    localStorage.setItem('keyWord', highlightWord);
  }

  return (<>
    {loading && (
      <div className="loading-overlay">
        <div className="spinner"></div>
        <div className="loading-text">資料查詢中，請稍候...</div>
      </div>
    )}
    <div className="TFAI-box">
      <div id="content-bg">
        <aside></aside>
        <div className="ctn-pic"><img alt="headPic" src={headPic} /></div>
      </div>
      <div className="container-xl">
        <div className="ctn-header">
          <div className="ctn-logo d-none d-lg-block">
            <Link to="/"><img src={TFAILogoMain} alt="TFAT logo" className="img-fluid" /></Link>
          </div>
          <div className="ctn-heading">
            <h1><span>檢索</span>結果</h1>
          </div>
        </div>
        <div className="ctn-area">
          <div className="searcher">
            <form>
              <div className="row">
                <div className="col-auto d-none d-sm-inline-block">
                  <button className={isGrid ? "btn btn-secondary active" : "btn btn-secondary"}
                    type="button" onClick={() => setIsGrid(true)}>
                    <i><ListUl /></i><span className=" ms-2 d-none d-lg-inline-block">列表</span>
                  </button>
                  <button className={!isGrid ? "btn btn-secondary active" : "btn btn-secondary"}
                    style={{ marginLeft: "5px" }} type="button" onClick={() => setIsGrid(false)}>
                    <i><Grid3x3GapFill /></i><span className="ms-2 d-none d-lg-inline-block">圖示</span>
                  </button>
                </div>
                <div className="col-7 col-md-7 col-sm-6 mb-3">
                  <div className="input-group">
                    <input id="input-keyword" type="text" className="form-control"
                      placeholder="查詢全文" value={searchWord} onChange={searchWordInput} />
                    {showAutofillList && <AutoSchBox searchWord={searchWord} width={inputRef} setSearchWord={setSearchWord} />}
                    <span id="submit" className="input-group-text btn-secondary" onClick={handleSearch} style={{ cursor: "pointer" }}><Search /></span>
                  </div>
                </div>
                <div className="col">
                  <button id="advanceBtn" className="accordion-button collapsed" style={{ whiteSpace: 'nowrap', width: 'auto' }} type="button"
                    data-bs-toggle="collapse" data-bs-target="#adv-search" onClick={advanceBtn}>
                    {btnText}
                  </button>
                </div>
              </div>
              <div id="adv-search" className="accordion-collapse collapse">
                <div className="accordion-body" style={{ paddingTop: '0px' }}>
                  {data.map((val, index) => (
                    <div key={index} className="row g-1 mb-3 mb-lg-1">
                      <div className="col-auto" style={{ whiteSpace: 'nowrap', width: 'auto' }}>
                        <select className="form-select" name="select" value={val.select} onChange={e => handleChange(e, index)}>
                          <option value={AND}>AND</option>
                          <option value={OR}>OR</option>
                          <option value={NOT}>NOT</option>
                        </select>
                      </div>
                      <div className="col-6">
                        <input type="text" className="form-control" placeholder="" name="input" value={val.input} onChange={e => handleChange(e, index)}></input>
                      </div>
                      {index === 0 &&
                        <div className="col-2" style={{ whiteSpace: 'nowrap' }}>
                          <button id="addBtn" className="btn btn-secondary" type="button" style={{ marginLeft: '7px', width: '40px' }}
                            onClick={() => handleAdd()} disabled={data.length < 4 ? false : true}>+</button>
                          <button className="btn btn-secondary" type="button" style={{ marginLeft: '7px', width: '40px' }}
                            onClick={() => handleDelete()} disabled={data.length > 1 ? false : true}>-</button>
                        </div>
                      }
                    </div>
                  ))}
                </div>
              </div>
              <div className="row">
                <div className="col col-md-10 col-lg-8">
                  <Select id="schType"
                    isMulti
                    options={options}
                    value={selectedOptionsJSON}
                    onChange={handleSelect}
                    closeMenuOnSelect={false}
                    placeholder="未選擇藏品類型，預設全選"
                    noOptionsMessage={() => '已選擇所有藏品類型'}
                    styles={{
                      control: (base, state) => ({
                        ...base,
                        border: '1px solid #949494',
                        boxShadow: 'none',
                        "&:focus-within": {
                          borderColor: 'rgba(214, 217, 0, 0.9)',
                          boxShadow: '0 0 0 1px rgba(200, 144, 89, 0.25);',
                        },
                      }),
                    }}
                  />
                </div>
              </div>
              <div className="row" style={{ marginTop: '15px' }}>
                <div className="input-group mb-2 custom-input-group">
                  <DatePicker className="form-control custom-date-picker" placeholderText="西元年(起)"
                    selected={sDate}
                    onChange={(date) => setSDate(date)} selectsStart
                    startDate={sDate} endDate={eDate}
                    dateFormat="yyyy" showYearPicker />
                  <label style={{ marginLeft: 10, marginRight: 10, display: 'flex', alignItems: 'center' }}>~</label>
                  <DatePicker className="form-control custom-date-picker" placeholderText="西元年(迄)"
                    selected={eDate}
                    onChange={(date) => setEDate(date)} selectsEnd
                    startDate={sDate} endDate={eDate}
                    dateFormat="yyyy" showYearPicker />
                </div>
                <div className="col-auto">
                  <div className="row g-2">
                    <label className="col-auto col-form-label">排序</label>
                    <div className="col-auto">
                      <select className="form-select" style={{ padding: "0.375rem 1.5rem 0.375rem 0.75rem" }}
                        value={orderColumn} onChange={changeOrderValue}>
                        <option value="標題相關性">標題相關性</option>
                        <option value="年份">年份</option>
                        <option value="藏品名稱">藏品名稱</option>
                        <option value="資料更新時間">資料更新時間</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div className="col-auto mb-3 mb-md-0">
                  <div className="row g-2">
                    <label className="col-auto col-form-label">方向</label>
                    <div className="col-auto">
                      <select className="form-select" value={orderType} onChange={changeDirectionValue}>
                        <option value="ASC">{ascText}</option>
                        <option value="DESC">{descText}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>
            </form>
          </div>
          <div className="result-area">
            <div className="on-search d-flex flex-column flex-md-row justify-content-between align-items-md-end">
              <p className="search-info">
                搜尋關鍵字 : <br />
                <span style={{ display: 'flex' }}>
                  {/* {this.getSearchWords()} */}
                  {highlightWord.trim() !== '' ? (
                    <span dangerouslySetInnerHTML={{ __html: renderWithHighlight1(highlightWord) }} />
                  ) : (
                    '無關鍵字，列出所有藏品'
                  )}
                </span>
                <br /><br />
                總筆數 : <span>{totalCount}</span>筆
              </p>
            </div>
            <div className={isGrid ? "result-listPic" : "result-listPic list-grid"}>
              {/* 使用map函數動態生成<Link>元素 */}
              {items && items.map((item, index) => (
                <Link key={index + 1} target={'_blank'} onClick={() => sendData(item)}
                  to={`/collection/detail?type=${item.categoryJson.category_id}&id=${item.collectiblesNo}`}>
                  <div className="result-item">
                    <div className="col-input">
                      <label className="form-check-label">{index + 1}.</label>
                    </div>
                    <div className="col-text">
                      <h2>
                        <div dangerouslySetInnerHTML={{ __html: renderWithHighlight(item.collectiblesTitle) }} />
                      </h2>
                      <div className=''>
                        <span>
                          類別：{item.categoryJson.category_name}<br />
                          {listDate(item)}<br />
                          {/* <div dangerouslySetInnerHTML={{ __html: renderWithHighlight2(item.collectiblesNo) }} /> */}
                          資料更新時間：{item.updateTime}<br />
                        </span>
                      </div>
                    </div>
                    {item.categoryJson.category_id !== "df" && item.picUrl && item.picUrl !== '' &&
                      <div className={"col-pic"} >
                        {!isGrid &&
                          <img alt="dataPic" className={"data-pic"} style={{ width: '100%' }} src={gridPic(item)} />}
                      </div>
                    }
                  </div>
                </Link>
              ))}
            </div>
            {/* <PageSelect/> */}
            <div id="page-control" className="position-sticky bottom-0">
              <div className="d-none d-sm-inline-block">
                <div className="row ">
                  <label className="col-auto col-form-label">每頁筆數</label>
                  <div className="col-auto">
                    <select className="form-select form-select-sm" aria-label="" value={recordsperpage} onChange={changeRecordsPerPage}>
                      <option value="10">10</option>
                      <option value="20">20</option>
                      <option value="50">50</option>
                      <option value="100">100</option>
                    </select>
                  </div>
                  <label className="col-auto col-form-label">總筆數<aside>{totalCount}</aside>筆 共<aside>{totalPage}</aside>頁</label>
                </div>
              </div>
              <div className="d-inline-block ms-sm-5">
                <nav aria-label="Page navigation">
                  <ul className="pagination pagination-sm">
                    <li className="page-item">
                      <div className="page-link" onClick={toFirstPage} aria-label="First">
                        <img alt="iL03" src={ToFirst} className="i-mark" />
                      </div>
                    </li>
                    <li className="page-item d-none d-sm-inline-block">
                      <div className="page-link" onClick={toPrevPage10} aria-label="Previous">
                        <img alt="iL02" src={BackTen} className="i-mark" />
                      </div>
                    </li>
                    <li className="page-item">
                      <div className="page-link" onClick={toPrevPage1} aria-label="Previous">
                        <img alt="iL01" src={BackOne} className="i-mark" />
                      </div>
                    </li>
                    <span className="jump-page">
                      <div className="row g-2">
                        <label className="col-auto col-form-label">目前頁面</label>
                        <div className="col-5">
                          <input type="text" className="form-control form-control-sm" value={page} onChange={changeCurrentPage} />
                        </div>
                      </div>
                    </span>
                    <li className="page-item">
                      <div className="page-link" onClick={toNextPage1} aria-label="Next">
                        <img alt="iR01" src={ForwardOne} className="i-mark" />
                      </div>
                    </li>
                    <li className="page-item d-none d-sm-inline-block">
                      <div className="page-link" onClick={toNextPage10} aria-label="Next">
                        <img alt="iR02" src={ForwardTen} className="i-mark" />
                      </div>
                    </li>
                    <li className="page-item">
                      <div className="page-link" onClick={toLastPage} aria-label="Last">
                        <img alt="iR03" src={ToLast} className="i-mark" />
                      </div>
                    </li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </>);
};

export default List;
